export enum EEmployeesColumnKey {
  User = 'user',
  Role = 'role',
  Email = 'email',
  Phone = 'phone',
  Counterparty = 'counterparty',
  Branch = 'branch_name',
  IBAN = 'iban',
  Status = 'status',
  Actions = 'actions',
  Menu = 'menu',
  Guid = 'guid',
}

export enum ECounterpartyStatus {
  Closed = 0,
  Active = 1,
  Blocked = 2,
}

export enum ECounterpartyAction {
  Edit = 'edit',
  Delete = 'delete',
}

export enum EEmployeesFormItemName {
  User = 'user',
  Role = 'role',
  Email = 'email',
  Phone = 'phone',
  Counterparty = 'counterparty',
  Branch = 'branch_guid',
  IBAN = 'iban',
  Status = 'status',
  Login = 'login',
  Password = 'password',
  Name = 'name',
  Surname = 'surname',
  PaternalName = 'paternal_name',
}

export enum EModalType {
  Create = 'create',
  Edit = 'edit',
}
